import { useSEO } from '@/hooks/useSEO';

export default function Terms() {
  useSEO({
    title: 'Kullanım Koşulları | Mayi Mimarlık',
    description: 'Mayi Mimarlık web sitesi kullanım koşulları ve online teklif sistemi sözleşmesi.',
    canonical: 'https://mayimimarlik.com/terms',
    geo: false,
  });

  return (
    <div className="bg-[#fafafa]" style={{ paddingTop: '160px', paddingBottom: '100px', minHeight: '100vh', width: '100%' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', backgroundColor: '#fff', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', padding: '3rem' }}>
        
        <section>
          <h1 style={{ fontSize: '2rem', fontWeight: 800, color: '#1a1a1a', marginBottom: '2rem', borderBottom: '2px solid #eee', paddingBottom: '1rem' }}>
            Kullanım Koşulları ve Teklif Sözleşmesi
          </h1>
          
          <div style={{ color: '#444', lineHeight: '1.8', fontSize: '0.95rem' }}>
            <p style={{ fontWeight: 600, marginBottom: '2rem' }}>KULLANICI VE BAYİ SATIŞ SÖZLEŞMESİ (TEKLİF SİSTEMİ)</p>

            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#333', marginTop: '1.5rem', marginBottom: '0.5rem' }}>1. Taraflar</h3>
            <p style={{ marginBottom: '1rem' }}>
              İşbu sözleşme, <strong>https://www.mayimimarlik.com</strong> sitesini kullanan ziyaretçi ("Kullanıcı") ile Mayi Mimarlık İnşaat Gıda Petrol Otomotiv Sanayi Ticaret Limited Şirketi arasında akdedilmiştir.
            </p>

            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#333', marginTop: '1.5rem', marginBottom: '0.5rem' }}>2. Hizmetin Niteliği (Teklif İsteme)</h3>
            <p style={{ marginBottom: '1rem' }}>
              <strong>https://www.mayimimarlik.com</strong> bir doğrudan e-ticaret satış sitesi olmayıp, bir ürün tanıtım ve teklif toplama platformudur. Sepete eklenen ürünler ve gönderilen formlar bir "sipariş" değil, "teklif talebi" niteliğindedir.
            </p>

            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#333', marginTop: '1.5rem', marginBottom: '0.5rem' }}>3. Fiyatlandırma ve Bağlayıcılık</h3>
            <p style={{ marginBottom: '1rem' }}>
              Sitede yer alan ürün fiyatları, döviz kurları, stok durumları ve vergi oranlarındaki değişiklikler nedeniyle güncelliğini yitirebilir. Kullanıcıya iletilen web sitesi üzerindeki fiyatlar nihai satış fiyatı değildir. Bağlayıcı olan tek fiyat, şirket yetkililerimiz tarafından tarafınıza yazılı (E-posta/Resmi Teklif Formu) olarak iletilen güncel tekliftir.
            </p>

            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#333', marginTop: '1.5rem', marginBottom: '0.5rem' }}>4. Kullanıcı Yükümlülükleri</h3>
            <p style={{ marginBottom: '1rem' }}>
              Kullanıcı, teklif formunda verdiği bilgilerin doğruluğunu beyan eder. Yanlış iletişim bilgileri nedeniyle oluşacak gecikmelerden Şirket sorumlu tutulamaz.
            </p>
          </div>
        </section>

      </div>
    </div>
  );
}
